import React, { Fragment } from "react";
import Form from "./form";
import EntityComponent from "../../../../common/entity-component";
import config from "./config";
import useSaveNotification from "../../../../../database/notifications/useSaveNotification";
import { Notification } from "../../../../../types/Notification";

export default function NotificationsFragment({
  notifications,
  isMobile,
  communityId,
}: {
  notifications: Notification[];
  isMobile: boolean;
  communityId?: string; // Optional, to associate notifications with a user
}) {
  let tabConfig = !isMobile ? config.tabConfig : config.mobileTabConfig;
  const saveNotification = useSaveNotification();

  const onCreateNotification = async (notification: Notification) => {
    const notificationWithUser: Notification = {
      ...notification,
      createdAt: new Date().toISOString(),
      communityId,
    };

    console.log("CreatingNotif", notificationWithUser);
    const notificationId = await saveNotification(notificationWithUser);
    return notificationId;
  };

  const onEditNotification = async (notification: Notification) => {
    // If editing is supported, implement the logic here
    console.log("Editing notification:", notification);
    return notification.id;
  };

  return (
    <Fragment>
      <EntityComponent
        canBeRemoved={false}
        canBeEdited={false}
        canBeCreated
        tabConfig={tabConfig}
        filterConfig={config.filterConfig}
        onRemoveItem={(item) => item} // Implement if needed
        singularEntityName="Notification"
        pluralEntityName="Notifications"
        dataset={notifications}
        onEditItem={onEditNotification}
        onCreateItem={onCreateNotification}
        Form={(props) => (
          <Form
            {...props}
            notifications={notifications}
            communityId={communityId}
          />
        )}
      />
    </Fragment>
  );
}
